import getParent from '../selectors';

export const getSelectedSampleId = state =>
  getParent(state).selectedSampleId;

export default getSelectedSampleId;
